/**
 * DevExtreme (esm/__internal/grids/new/grid_core/pager/utils.js)
 * Version: 25.1.4
 * Build date: Tue Aug 05 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export function calculatePageSizes(allowedPageSizes, pageSizesConfig, pageSize) {
    if (Array.isArray(pageSizesConfig)) {
        return pageSizesConfig
    }
    if (Array.isArray(allowedPageSizes) && allowedPageSizes.includes(pageSize)) {
        return allowedPageSizes
    }
    if (pageSizesConfig && pageSize > 1) {
        return [Math.floor(pageSize / 2), pageSize, 2 * pageSize]
    }
    return []
}
export function isVisible(visibleConfig, pageCount) {
    if ("auto" === visibleConfig) {
        return pageCount > 1
    }
    return visibleConfig
}
